import theme from '../../themes/theme';

const {
  Layout: { notificationRow, seconday_title, clearButtonBG, black },
} = theme;

export default {
  topBar: {
    width: '10%',
    height: '5em',
    background: 'transparent',
    boxShadow: 'none',
    color: '#333',
  },
  toolbarButtons: {
    marginLeft: '42%',
    backgroundColor: clearButtonBG,
    color: notificationRow,
    // height: '2.62em',
    // width: '8.5em',
    borderRadius: '1.56em',
    padding: '0.4em 1.8em',
  },
  closeButton: {
    height: '4.25em',
    width: '4.25em',
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    color: seconday_title,
  },
  listBox: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: '"Trebuchet MS", Helvetica, sans-serif',
    paddingTop: '1em',
    marginTop: '1.75em',
  },
  itemContainer: {
    backgroundColor: notificationRow,
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'stretch',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginBottom: '0.6em',
    height: '7em',
    borderRadius: '0',
  },
  itemDivider: {
    paddingLeft: '0.5em',
    color: seconday_title,
    height: '2.9em',
  },
  itemDividerIcon: {
    height: '1.5em',
    width: '1.5em',
  },
  itemDividerText: {
    display: 'inline',
    paddingLeft: '0.5em',
    fontSize: '1.25em',
  },
  itemAvatar: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    alignConent: 'center',
    width: '7em',
    height: '100%',
  },
  itemDetails: {
    flex: 8,
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingLeft: '1.2em',
    height: '100%',
  },
  itemTitleText: {
    fontSize: '1.4em',
    color: 'rgb(29, 31, 32)',
    fontWeight: 600,
  },
  itemSubtitle: {
    fontSize: '1.2em',
    color: seconday_title,
  },
  itemTimeAndActions: {
    flex: 3,
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
  },
  itemActions: {
    flex: 1,
    display: 'flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
    justifyContent: 'center',
  },

  bottomBar: {
    width: '100%',
    height: '7em',
    top: 'auto',
    bottom: 0,
    border: 0,
    boxShadow: 'none',
    background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)',
  },
  menuButton: {
    marginRight: 0,
  },
  errorMessage: {
    color: black,
    fontSize: '3em',
    position: 'absolute',
    height: '3em',
    top: '56%',
    left: '46%',
    marginLeft: '-3em',
    marginTop: '-3em',
  },
};
